import React, { useContext, useEffect, useRef, useState } from 'react';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useFormContext } from '../Context/Context';
import { useInputValues } from '../Context/InputValuesContext';
import { useErrorContext } from '../Context/ErrorContext';
import { useReadOnly } from '../Context/ReadOnlyContext';
import { FinalValuesContext } from '../Context/FinalValuesContext';
import ConvertTitle from './ConvertTitle';

// import NumberHeaderInput from './NumberHeaderInput';
import NumberInputField from './Number/NumberInputField';
import NumberSubLabelInput from './Number/NumberSubLabelInput';
import { fillNumberInputValue } from './Number/numberHelpers';
import NumberHeaderInput from './Number/NumberHeaderInput';

const Number = ({ id, header, placeholder }) => {
  const { drawerData } = useFormContext();
  const { inputValues } = useInputValues();
  const { setMistake } = useErrorContext();
  const { readOnly } = useReadOnly();
  const { finalSelectValues } = useContext(FinalValuesContext);
  const location = useLocation();
  const currentPage = location.pathname;

  const containerRef = useRef(null);

  const existingComponentIndex = drawerData.findIndex(component => component.id === id);
  const isReadOnly = currentPage.startsWith('/publish') || currentPage.startsWith('/card-form/publish') || currentPage.startsWith('/user/fill-form/');

  const switchHeader = header || drawerData[existingComponentIndex]?.state.numberValue || 'شماره';
  const switchSubHeader = drawerData[existingComponentIndex]?.state.subNumberValue || '';

  const [numberValue, setNumberValue] = useState(switchHeader);
  const [numberInputValue, setNumberInputValue] = useState(drawerData[existingComponentIndex]?.state.mainNumberInputValue || '');
  const [subNumberValue, setSubNumberValue] = useState(switchSubHeader);
  const [isSubHeaderVisible, setSubHeaderVisible] = useState(false);
  const [isHeadingFocused, setHeadingFocused] = useState(false);
  const [error, setError] = useState('');
  const [condition, setCondition] = useState(false);

  const theme = useTheme();
  const isUpXxl = useMediaQuery(theme.breakpoints.up('xxs'));
  const SubHeadingInputFontSize = isUpXxl ? '14px' : '12px';
  const HeadingColor = theme.palette.blue[700];

  // 🔍 FieldCondition Logic
  const titleIndex = finalSelectValues.findIndex(item => item.name === 'FieldCondition');
  const title = ConvertTitle({ title: finalSelectValues[titleIndex]?.value });
  const dataIndex = drawerData.findIndex(item => item.title === title);
  const dataCondition = drawerData[dataIndex]?.state.readOnly;

  const handleCondition = () => {
    if (currentPage === '/Publish') {
      setCondition((readOnly || dataCondition) && title === 'Number');
    } else {
      setCondition(false);
    }
  };

  const handleHeadingFocus = (event) => {
    setHeadingFocused(true);
    event.target.select();
  };

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setSubHeaderVisible(false);
      setHeadingFocused(false);
    } else {
      setSubHeaderVisible(true);
      setHeadingFocused(true);
    }
  };

  const handleFindError = () => {
    const index = inputValues.findIndex(item => item.name === 'ThisFieldCanOnlyContainNumericValues');
    if (index !== -1) setError(inputValues[index].value);
    else setError('');
  };

  const handleNumberInputChange = (event) => {
    const value = event.target.value;
    setNumberInputValue(value);

    if (isNaN(value)) {
      handleFindError();
      setMistake(true);
    } else {
      setError('');
      setMistake(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  useEffect(() => {
    fillNumberInputValue({
      drawerData,
      index: existingComponentIndex,
      values: { numberValue, numberInputValue, subNumberValue },
      readOnly
    });
  }, [id, numberValue, numberInputValue, subNumberValue]);

  useEffect(() => {
    handleCondition();
  }, [finalSelectValues, readOnly]);

  return (
    <Grid
      mb={currentPage.startsWith('/build') || currentPage.startsWith('/publish') ? '28px' : '50px'}
      p={drawerData.length > 0 ? (currentPage.startsWith('/build') || currentPage.startsWith('/publish') || currentPage.startsWith('/user/fill-form') ? '12px 10px' : { xs: '12px', md: '24px' }) : '0px'}
      mx={currentPage === '/build' || currentPage === '/publish' ? '4px' : '0px'}
      borderRadius="3px"
      width="100%"
      bgcolor="white"
      ref={containerRef}
      border={`2px solid ${isHeadingFocused && drawerData.length > 0 && !isReadOnly ? '#0293e2' : 'transparent'}`}
      onClick={handleClickOutside}
    >
      <Grid className="HeadingInput" pb="14px">
        <NumberHeaderInput
          value={numberValue}
          onChange={(e) => setNumberValue(e.target.value)}
          onClick={handleClickOutside}
          onFocus={isReadOnly ? null : handleHeadingFocus}
          readOnly={isReadOnly || condition}
          color={HeadingColor}
        />
      </Grid>

      <Grid>
        <NumberInputField
          value={numberInputValue}
          onChange={handleNumberInputChange}
          placeholder={placeholder}
          error={error}
          readOnly={condition}
          color={HeadingColor}
        />
      </Grid>

      <Grid display={isReadOnly && subNumberValue === '' ? 'none' : 'block'}>
        {isSubHeaderVisible && (
          <Grid className="subHeader" pb="14px">
            <NumberSubLabelInput
              value={subNumberValue}
              onChange={(e) => setSubNumberValue(e.target.value)}
              readOnly={isReadOnly || condition}
              fontSize={SubHeadingInputFontSize}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default Number;